module.exports = __webpack_public_path__ + "img/404.39c54421.png";